import React from "react";
import Modal from "../../../components/general/Modal";
import Button from "../../../components/general/Button";
import GlobalStyle from "../../../styles/globalStyles";
import { Container, SubTitle, Title, Footer } from "./styles";
import { useDispatch } from "react-redux";
import { handleUpgradeRank } from "../../../state/users/actions";
import { toastAlert } from "../../../components/Toastify/index";

const UpgradeRankModal = ({ isOpen, onClose, item }) => {
  const dispatch = useDispatch();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector="#root"
      className="nodrag"
    >
      <GlobalStyle />
      <Container>
        <Title>Confirme a Modificação de Rank </Title>
        <SubTitle>Usuario a ser promovido: {item.username} </SubTitle>
        <Footer>
          <Button content={"Cancelar"} onClick={onClose} outline />
          <Button
            content={"Promover"}
            onClick={() =>
              dispatch(
                handleUpgradeRank({
                  userId: item._id,
                })
              )
                .then(() => {
                  toastAlert({
                    msg:
                      "Usuario " +
                      item.username +
                      " transformado em Gerente com sucesso!",
                  });
                  onClose();
                })
                .catch(() =>
                  toastAlert({
                    msg:
                      "Ocorreu um erro ao promovoer o usuario : " +
                      item.username +
                      "!",
                    isError: true,
                  })
                )
            }
          />
        </Footer>
      </Container>
    </Modal>
  );
};

export default UpgradeRankModal;
